import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthQueueData } from './AuthQueueData';
import moment from 'moment';
import { Router } from '@angular/router';
import { DATE_WITH_SECONDS_AMPM } from '../../../../assets/constants';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-auth-queue:not(p)',
    templateUrl: './auth-queue.component.html',
    styleUrls: ['./queue.component.scss'],
    standalone: false
})
export class AuthQueueComponent implements OnInit {
  @Input() queue!: AuthQueueData;
  @Input() isSelectable: boolean = true;
  @Input() isMyQueue: boolean = false;
  @Input() toolTipList!: AuthQueueData[];
  @Input() timezone!: string;
  @Output() authAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() queueAction: EventEmitter<any> = new EventEmitter<any>();
  dateFormat = DATE_WITH_SECONDS_AMPM;
  SemiUrgentDueDate = moment().add(24, 'hours').format('YYYY-MM-DDTHH:mm:ss');
  UrgentDueDate = moment().format('YYYY-MM-DDTHH:mm:ss');

  constructor(private router: Router
  ) { 
    if (this.timezone){
      this.SemiUrgentDueDate = moment().add(24, 'hours').tz(this.timezone).format('YYYY-MM-DDTHH:mm:ss');
      this.UrgentDueDate = moment().tz(this.timezone).format('YYYY-MM-DDTHH:mm:ss');
    }
  }

  onChange(ob: MatCheckboxChange) {
    this.queueAction.forEach(item => { });
    this.authAction.emit({ checked:ob.checked, authNumber: this.queue.authNumber });
  } 

  ngOnInit(): void {

  }

  emitQueueAction(element: any) {
    this.queueAction.emit(element);
    let AuthNumArr = element.authNumber.split("-");
    //alert('View this auth');
    //location.href = '/member/authorization-intake/' + element.authIntakeId + '/' + AuthNumArr[0] + '/';
    this.router.navigate([`/member/authorization-intake/${element.authIntakeId}/${AuthNumArr[0]}`], { skipLocationChange: true });
  }

  getToolTip(procCodeId: string) {
    if (procCodeId == '') {
      return 'N/A';
    }
    var tip = this.toolTipList?.filter((p: AuthQueueData) => p.procCodeId == procCodeId)?.[0]?.procDesc;
    if (tip == null) {
      return `${procCodeId}: N/A`;
    }
    return `${procCodeId}: ${tip}`;
  }

  getUrgency(queue: AuthQueueData){
    if (this.timezone){
      this.SemiUrgentDueDate = moment().add(24, 'hours').tz(this.timezone).format('YYYY-MM-DDTHH:mm:ss');
      this.UrgentDueDate = moment().tz(this.timezone).format('YYYY-MM-DDTHH:mm:ss');
    }
    var dueDate = moment(queue.dueDate).tz(this.timezone).toDate();
    if (dueDate.getTime() < moment(this.UrgentDueDate).toDate().getTime()){
      return 'urgent';
    }
    if (dueDate.getTime() > moment(this.UrgentDueDate).toDate().getTime() && dueDate.getTime() < moment(this.SemiUrgentDueDate).toDate().getTime()){
      return 'semi-urgent';
    }
    if(queue.showAsNew){
      return 'new';
    }
    return '';
  }

  getDateUrgency(queue: AuthQueueData){
    if (this.timezone){
      this.SemiUrgentDueDate = moment().add(24, 'hours').tz(this.timezone).format('YYYY-MM-DDTHH:mm:ss');
      this.UrgentDueDate = moment().tz(this.timezone).format('YYYY-MM-DDTHH:mm:ss');
    }
    var dueDate = moment(queue.dueDate).tz(this.timezone).toDate();
    if (dueDate.getTime() < moment(this.UrgentDueDate).toDate().getTime()){
      return 'text-danger';
    }
    if (dueDate.getTime() > moment(this.UrgentDueDate).toDate().getTime() && dueDate.getTime() < moment(this.SemiUrgentDueDate).toDate().getTime()){
      return 'text-warning';
    }
    return '';
  }
}
